<template>
  <div class="bg-white shadow-lg rounded-sm px-6 py-5">
    <div :class="cn('flex flex-row items-center overflow-hidden justify-between', props.headerClass)">
      <BaseTypography :variant="props.titleTag" class="text-[1rem]">{{ props.title }}</BaseTypography>
      <component v-if="props.icon" :is="props.icon" class="w-[2em] h-[2em]" />
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { Component } from "vue";

interface AccountCardProps {
  title: string;
  titleTag?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  icon?: Component;
  headerClass?: string;
}
const props = withDefaults(defineProps<AccountCardProps>(), {
  titleTag: "h3",
});
</script>
